import BoxShadows from "./components/box-shadows/BoxShadows";

function App() {
  return (
    <BoxShadows />
  );
}

export default App;
